const firebaseConfig = {
    apiKey: "AIzaSyBZfhGMk4Le0Vne6JCv6sjZIxjK264YqWk",
    authDomain: "my-dental-clinic-baaf8.firebaseapp.com",
    projectId: "my-dental-clinic-baaf8",
    storageBucket: "my-dental-clinic-baaf8.appspot.com",
    messagingSenderId: "993400055412",
    appId: "1:993400055412:web:9a14a04cd2ad17e39c5321"
};
export default firebaseConfig;